import React, { Suspense, lazy, useEffect, useState } from "react";
import { ArrowRight, ChartLineUp, DeviceMobile, Factory, Pulse } from "@phosphor-icons/react";
import { Link, Navigate, Route, Routes } from "react-router-dom";

const MobileApp = lazy(() => import("./mobile/index.jsx").then((module) => ({ default: module.MobileApp })));
const DashboardApp = lazy(() => import("./dashboard/index.jsx").then((module) => ({ default: module.DashboardApp })));
const Workbench = lazy(() => import('./workbench/Workbench.jsx'));
const CompanyApp = lazy(() => import('./company/CompanyApp.jsx'));
const Pilot = lazy(() => import('./pilot/Pilot.jsx'));

function RouteLoading() {
  return (
    <div className="route-loading" aria-label="正在加载应用">
      <span />
      <span />
      <span />
    </div>
  );
}

function Gateway() {
  return (
    <main className="gateway-shell">
      <header className="gateway-header">
        <div className="brand-lockup">
          <span className="brand-mark"><Factory weight="fill" /></span>
          <div>
            <strong>制造全过程追溯</strong>
            <span>本地可运行示例</span>
          </div>
        </div>
        <span className="live-chip"><Pulse weight="fill" /> 数据库实时写入</span>
      </header>

      <section className="gateway-intro">
        <p className="gateway-kicker">销售订单 → 产品品号 → MO号</p>
        <h1>同一套数量台账，连接现场每一次报工与管理层每一次追问。</h1>
        <p>
          3D打印与热处理按生产批号执行，后续工序按固定MO二维码执行。每个动作新增记录，
          看板从订单逐层钻取到人员、数量、照片和异常。
        </p>
      </section>

      <section className="gateway-actions" aria-label="系统入口">
        <Link className="gateway-action gateway-action--board" to="/workbench"><span className="gateway-action-icon"><Factory /></span><span><small>业务与员工入口</small><strong>全流程工作台</strong><em>订单、技术、排产、任务、资源和AI监督</em></span><ArrowRight /></Link>
        <Link className="gateway-action gateway-action--field" to="/m/scan">
          <span className="gateway-action-icon"><DeviceMobile /></span>
          <span>
            <small>现场入口</small>
            <strong>手机扫码报工</strong>
            <em>身份核验、数量、照片、异常与历史</em>
          </span>
          <ArrowRight className="gateway-arrow" />
        </Link>
        <Link className="gateway-action gateway-action--board" to="/dashboard">
          <span className="gateway-action-icon"><ChartLineUp /></span>
          <span>
            <small>管理入口</small>
            <strong>CEO制造看板</strong>
            <em>订单、产品、MO、生产批号与工序瓶颈</em>
          </span>
          <ArrowRight className="gateway-arrow" />
        </Link>
      </section>

      <footer className="gateway-footer">
        <span>演示数据可重置，所有报工与附件均真实写入本地数据库。</span>
        <span className="mono">SQLite WAL · append-only events · SSE</span>
      </footer>
    </main>
  );
}

export function App() {
  const [mode,setMode]=useState(null);
  const [verification,setVerification]=useState(false);
  const [networkPilot,setNetworkPilot]=useState(false);
  useEffect(()=>{fetch('/api/system-info').then(r=>r.json()).then(r=>{setMode(r.sourceMode||'LOCAL');setVerification(Boolean(r.verificationMode));setNetworkPilot(r.identityMode==='NETWORK_PILOT')}).catch(()=>setMode('LOCAL'));},[]);
  if(mode===null)return <RouteLoading/>;
  return (
    <Suspense fallback={<RouteLoading />}>
      {networkPilot&&<div className="network-pilot-banner" role="note"><strong>免登录试点 · 仅限已放行网络</strong><span>当前操作人未核验；记录不代表张优或其他员工。原底表只读，业务历史追加保存。</span></div>}
      {verification&&<div role="note" style={{padding:'10px 16px',background:'#49371c',color:'#fff0ce',textAlign:'center',fontSize:13}}>隔离验收环境：真实编号，测试报工。此处禁止登记正式生产事实。</div>}
      <Routes>
        <Route path="/" element={<Navigate to="/workspace" replace/>} />
        <Route path="/workspace/*" element={<Pilot/>}/>
        <Route path="/company/*" element={<CompanyApp/>}/>
        <Route path="/m/*" element={<MobileApp />} />
        <Route path="/report/*" element={<Navigate to="/m/scan" replace />} />
        <Route path="/dashboard/*" element={mode==='FEIERKANG'?<Navigate to="/company" replace/>:<DashboardApp />} />
        <Route path="/workbench/*" element={<Workbench />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
